import React, { FC } from 'react';
import UISkeleton from 'react-loading-skeleton';
import style from 'components/posts/detail/overview/leftSection/preview/skeleton/Skeleton.module.scss';

type Props = {};

const Skeleton: FC<Props> = (props) => {
  return (
    <div className={style.skeleton}>
      <UISkeleton style={{ width: '100%', height: '100%' }} />
    </div>
  );
};

export default Skeleton;
